/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Zoom_MonthsInputs */

const en_tl_zoom_months = /** @type {(inputs: Tl_Zoom_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Months`)
};

const de_tl_zoom_months = /** @type {(inputs: Tl_Zoom_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monate`)
};

/**
* | output |
* | --- |
* | "Months" |
*
* @param {Tl_Zoom_MonthsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_zoom_months = /** @type {((inputs?: Tl_Zoom_MonthsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Zoom_MonthsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_zoom_months(inputs)
	return en_tl_zoom_months(inputs)
});